angular.module('bmsApp.merrymaids.cis').controller('MMCisSaveCtrl', function (
      $state
    , $scope
    , $window
    , moment
    , MMCisSvc
    , LicenseOptionsSvc
){


    function init(){

        //set the available years
        let avalibleYears = 5;

        for(var i =0; i <= avalibleYears; i++) {
            self.years.push(moment().subtract(i, 'years').format('YYYY'));
        }

        MMCisSvc.read({type: 'year'}).then(function(response){
            self.yearData = response.data.cis_year_data;
        });

        LicenseOptionsSvc.license().then(function (response) {
            self.licenses = response.data.options
        });
        
    }

    function onOverviewChange(){
        self.cis_data = null;
        self.selectedYear = null;
        self.selectedWeekData = null;
        self.errors = null;
        if(!self.yearly) {
            self.yearly = true;
            MMCisSvc.read({type: 'year'}).then(function(response){
              self.yearData = response.data.cis_year_data;
              self.selectedYear = null;
            });
        } else {
            self.yearly = false;
        }
    }

    function onYearInputChange() {

        if  (self.yearly) {

            if(self.selectedYear == null){
                self.cis_data = null;
            }else{
                MMCisSvc.read({type: 'year', year: self.selectedYear.year}).then(function(response){
                    self.cis_data = response.data.cis_year_data;
                });
            }

        }else{

            if(self.selectedYear == null){
                self.weekData = null;
            }else{
                MMCisSvc.getWeekData({year: self.selectedYear}).then(function(response){
                    self.weekData = response.data.cis_week_data;
                });
            }

        }

    }

    function onWeekInputChange(){

        MMCisSvc.read({type: 'week' , year: self.selectedYear, weekBeginning: self.selectedWeekData.date}).then(
            function (response) {
                if  (response.data.cis_week_data) {
                    self.cis_data = response.data.cis_week_data;
                    self.cis_data.update = true;
                } else {
                  self.cis_data = {};
                }
            }
        )

    }

    function submit() {

        if(self.yearly) {

            try {
                self.cis_data.week_beginning = self.cis_data.year+"-01-01";
                self.cis_data.year = self.selectedYear ? self.selectedYear.year : self.cis_data.year;
                self.cis_data.license_id = self.cis_data.license.id;
                self.cis_data.period = 'year';
            }catch (err) {
                self.errors = err;
            }

            MMCisSvc.save(self.cis_data).then(function(response){
                console.log(response.data);
            }, function (error){
                self.errors = error;
            });

        }else{

            try {
                self.cis_data.week_beginning = self.selectedWeekData.date;
                self.cis_data.year = self.selectedYear;
                self.cis_data.license_id = self.cis_data.license.id;
                self.cis_data.period = 'week';
            }catch (err) {
                self.errors = err;
            }

            MMCisSvc.save(self.cis_data).then(function(response){
                console.log(response.data);
            }, function (error){
                self.errors = error;
            });
        }

    }

    var self = $scope.MMCisSaveCtrl = {

        methods: {
            init: init,
            onYearInputChange: onYearInputChange,
            onWeekInputChange: onWeekInputChange,
            onOverviewChange: onOverviewChange,
            submit: submit
        },
        yearly: true,

        licenses: {},

        selectedLicense: null,
        years: [],
        selectedYear: null,
        weekData: null,
        selectedWeekData: null,

        cis_data: {},

        yearData: null,
        errors: null

    }


});